<template>
  <div class="wrapper log-bg overflow-hidden" id="aaaa">
    <Menu />
    <div class="body-area">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="team-list d-flex section--demo-2">
              <div class="glide" id="topcarousel">
                <div class="glide__track" data-glide-el="track">
                  <ul class="glide__slides">
                    <li class="glide__slide" v-for="(item, index) in data" :key="index">
                      <div
                        class="team-list-item eurolig slider-box position-relative"
                        :class="index == activeItem ? 'active' : ''"
                      >
                        <h1 class="fs-18 fc-5">
                          {{item.stats.leagueName.replace('Tüm Maçlar', 'Tüm\nMaçlar')}}
                          <br />
                          <span class="fs-24">Takım Kadrosu</span>
                        </h1>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="glide" id="bottomCarousel">
          <ul class="glide__slides">
            <li class="glide__slide">
              <div>
                <!-- BEGINEUROLEAGUE STATISTICS -->

                <div class="col-12">
                  <div class="item-box">
                    <div class="box-body px-0">
                      <div class="row bb-1 py-2 no-gutters">
                        <div class="col-4 text-center">
                          <span class="fs-11 fc-2 font-weight-bold d-block">Toplam Maç</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold rbs d-block"
                          >{{item.stats.totalGame}}</span>
                        </div>
                        <div class="col-4 text-center">
                          <span class="fs-11 fc-2 font-weight-bold d-block">Galibiyet</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold rbs d-block"
                          >{{item.stats.totalWin}}</span>
                        </div>
                        <div class="col-4 text-center">
                          <span class="fs-11 fc-2 font-weight-bold d-block">Mağlubiyet</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold rbs d-block"
                          >{{item.stats.totalLoss}}</span>
                        </div>
                      </div>
                      <div class="score-board bb-1 py-3">
                        <table>
                          <tbody>
                            <tr>
                              <td>
                                <span
                                  class="bar blue fs-24"
                                  :style="'width: '+(item.stats.scoreAverages.game.team)+'%; padding-right: 5px'"
                                >{{item.stats.scoreAverages.game.team}}</span>
                              </td>
                              <td class="mid">
                                <span>Maç Başına Sayı</span>
                              </td>
                              <td>
                                <span
                                  class="bar grey fs-24"
                                  :style="'width: '+(item.stats.scoreAverages.game.rivals)+'%; padding-left: 5px;'"
                                >{{item.stats.scoreAverages.game.rivals}}</span>
                              </td>
                            </tr>

                            <tr v-for="(ii, iindex) in getScores" :key="iindex">
                              <td>
                                <span class="bar blue fs-16" :style="'width: '+(ii.home)+'%'">
                                  <span style="position: absolute; right: 5px; top: 5px">{{ii.home}}</span>
                                </span>
                              </td>
                              <td class="mid">
                                <span>{{ii.title}}</span>
                              </td>
                              <td>
                                <span class="bar grey fs-16" :style="'width: '+(ii.away)+'%'">
                                  <span style="position: absolute; left: 5px; top: 5px">{{ii.away}}</span>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="row no-gutters mt-2">
                        <div class="col-4 br-1 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">Serbest Atış</span>
                          <span class="fs-24 fc-1 font-weight-bold d-block">
                            <span class="fs-18">%</span>
                            {{item.stats.shootAverages.freeThrow.average}}
                          </span>
                        </div>
                        <div class="col-4 br-1 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">2 Sayı</span>
                          <span class="fs-24 fc-1 font-weight-bold d-block">
                            <span class="fs-18">%</span>
                            {{item.stats.shootAverages.twoPoint.average}}
                          </span>
                        </div>
                        <div class="col-4 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">3 Sayı</span>
                          <span class="fs-24 fc-1 font-weight-bold d-block">
                            <span class="fs-18">%</span>
                            {{item.stats.shootAverages.threePoint.average}}
                          </span>
                        </div>

                        <div class="col-4 br-1 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">S. Ribaunt</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold d-block"
                          >{{item.stats.seasonAverages.defensiveRebounds}}</span>
                        </div>
                        <div class="col-4 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">H. Ribaunt</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold d-block"
                          >{{item.stats.seasonAverages.offensiveRebounds}}</span>
                        </div>
                        <div class="col-4 br-1 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">Asist</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold d-block"
                          >{{item.stats.seasonAverages.fouls}}</span>
                        </div>
                        <div class="col-4 br-1 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">Top Çalma</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold d-block"
                          >{{item.stats.seasonAverages.assists}}</span>
                        </div>
                        <div class="col-4 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">Top Kaybı</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold d-block"
                          >{{item.stats.seasonAverages.steals}}</span>
                        </div>
                        <div class="col-4 br-1 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">Faul</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold d-block"
                          >{{item.stats.seasonAverages.turnovers}}</span>
                        </div>
                        <div class="col-4 br-1 my-2 text-center">
                          <span class="fs-11 fc-2 d-block">Blok</span>
                          <span
                            class="fs-24 fc-1 font-weight-bold d-block"
                          >{{item.stats.seasonAverages.blocks}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="score-area mt-5">
                    <img src="static/img/saha.png" class="w-100" />
                    <div class="one-shot shot clearfix">
                      <div class="count">1</div>
                      <div class="stats">
                        <h1 class="fs-18">%{{item.stats.shootAverages.freeThrow.average}}</h1>
                        <h2
                          class="fs-12"
                        >{{item.stats.shootAverages.freeThrow.total}} / {{item.stats.shootAverages.freeThrow.scored}}</h2>
                      </div>
                    </div>
                    <div class="two-shot shot clearfix">
                      <div class="count">2</div>
                      <div class="stats">
                        <h1 class="fs-18">%{{item.stats.shootAverages.twoPoint.average}}</h1>
                        <h2
                          class="fs-12"
                        >{{item.stats.shootAverages.twoPoint.total}} / {{item.stats.shootAverages.twoPoint.scored}}</h2>
                      </div>
                    </div>
                    <div class="three-shot shot clearfix">
                      <div class="count">3</div>
                      <div class="stats">
                        <h1 class="fs-18">%{{item.stats.shootAverages.threePoint.average}}</h1>
                        <h2
                          class="fs-12"
                        >{{item.stats.shootAverages.threePoint.total}} / {{item.stats.shootAverages.threePoint.scored}}</h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12" v-if="item.standingsInJson">
                  <div class="item-box">
                    <table class="table">
                      <thead>
                        <tr class="fs-10 fc-6 font-weight-bold">
                          <th></th>
                          <th></th>
                          <th>O</th>
                          <th>G</th>
                          <th>M</th>
                          <th>P</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          class="fs-12"
                          :class="i.team_name.toLowerCase() == 'anadolu efes' ? 'fc-1 font-weight-bold' : ''"
                          v-for="(i, index) in item.standingsInJson"
                          :key="index"
                        >
                          <td>
                            <span class="fs-13 fc-6">{{i.place}}</span>
                          </td>
                          <td>{{i.team_name}}</td>
                          <td>{{i.played}}</td>
                          <td>{{i.win}}</td>
                          <td>{{i.loss}}</td>
                          <td>{{i.points}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- END EUROLEAGUE STATISTICS -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
import Glide from "@glidejs/glide";
export default {
  name: "Statistics",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      data: [],
      activeItem: 0,
      topCarousel: null,
      bottomCarousel: null,
      tab: 0
    };
  },
  methods: {},
  beforeMount() {
    axios.get("istatistik/index").then(res => {
      this.data = [res.data.all, res.data.tael, res.data.bsl, res.data.sttk];

      setTimeout(() => {
        this.topCarousel = new Glide("#topcarousel", {
          peek: { before: 0, after: 70 }
        }).mount();

        this.topCarousel.on(["move.after"], () => {
          this.activeItem = this.topCarousel.index;
        });
      }, 1000);
    });
  },
  computed: {
    item() {
      return this.data[this.activeItem];
    },
    getScores() {
      return [
        {
          title: "1.P",
          home: this.item.stats.scoreAverages.Q1.team,
          away: this.item.stats.scoreAverages.Q1.rivals
        },
        {
          title: "2.P",
          home: this.item.stats.scoreAverages.Q2.team,
          away: this.item.stats.scoreAverages.Q2.rivals
        },
        {
          title: "3.P",
          home: this.item.stats.scoreAverages.Q3.team,
          away: this.item.stats.scoreAverages.Q3.rivals
        },
        {
          title: "4.P",
          home: this.item.stats.scoreAverages.Q4.team,
          away: this.item.stats.scoreAverages.Q4.rivals
        }
      ];
    }
  }
};
</script>

<style>
#aaaa .slider-box::before {
  content: "" !important;
  display: none !important;
}

#aaaa .VueCarousel {
  width: 100%;
}

.team-list .team-list-item.eurolig {
  padding: 25px 31px 17px;
  padding-right: 0px;
  padding-left: 20px;
}

.glide__track {
  overflow: unset;
}

.score-board table .bar {
  min-width: 0%;
  text-shadow: 0px 0px 5px rgba(0, 0, 0, 1);
  padding: 0px;
  height: 30px;
  margin-bottom: 5px;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/pages/Statistics.vue